import {
  ADMINS,
  SHOW_ADMIN,
  CREATE_ADMIN,
  DELETE_ADMIN,
  UPDATE_ADMIN,
  SEARCH_ADMINS,
} from '../actions/admins/actionTypes';
import CLEAR_ERROR from '../actions/global/actionTypes';

const defaultState = {
  admins: [],
  currentAdmin: {},
  isFetching: false,
  error: {},
  total: 0,
  pages: 0,
};

const adminsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case `${ADMINS}_REQUEST`:
    case `${SEARCH_ADMINS}_REQUEST`:
      return {
        ...state,
        isFetching: true,
        error: {},
        admins: [],
        total: 0,
        pages: 0,
      };
    case `${ADMINS}_SUCCESS`:
    case `${SEARCH_ADMINS}_SUCCESS`:
      return {
        ...state,
        isFetching: false,
        admins: action.admins,
        total: action.total,
        pages: action.pages,
      };
    case `${SHOW_ADMIN}_REQUEST`:
    case `${CREATE_ADMIN}_REQUEST`:
      return { ...state, isFetching: true, error: {}, currentAdmin: {} };
    case `${SHOW_ADMIN}_SUCCESS`:
    case `${UPDATE_ADMIN}_SUCCESS`:
      return { ...state, isFetching: false, currentAdmin: action.admin };
    case `${CREATE_ADMIN}_SUCCESS`:
      return { ...state, isFetching: false };
    case `${DELETE_ADMIN}_REQUEST`:
    case `${UPDATE_ADMIN}_REQUEST`:
      return { ...state, isFetching: true, error: {} };
    case `${DELETE_ADMIN}_SUCCESS`:
      return {
        ...state,
        isFetching: false,
        admins: state.admins.filter(admin => admin.id !== action.id),
      };
    case `${ADMINS}_ERROR`:
    case `${SHOW_ADMIN}_ERROR`:
    case `${CREATE_ADMIN}_ERROR`:
    case `${DELETE_ADMIN}_ERROR`:
    case `${UPDATE_ADMIN}_ERROR`:
    case `${SEARCH_ADMINS}_ERROR`:
      return { ...state, isFetching: false, error: action.error };
    case CLEAR_ERROR:
      return { ...state, error: {} };
    default:
      return state;
  }
};

export default adminsReducer;



// WEBPACK FOOTER //
// ./src/reducers/admins.js